// Generated by scripts/build-canonical.ts from src/data/source/*.json.
// Do not edit by hand — re-run the script to refresh. This is schema v2 (canonical items
// catalog) — it coexists with the legacy per-category files, it does not replace them yet.

/** Non-English locales this item has a translated name in. Always paired with the default
 * locale by callers (see alternate-locales.ts#localesForItem) — this only carries the extras. */
export default {
  "african-olive-pigeon": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "afternoon-tea": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "alpine-longhorn-beetle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "amazing-seasoning": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "american-flamingo": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "amethyst-flower-beetle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "amur-falcon": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "angelfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "anglerfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "ant": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "anthurium": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "anthurium-seeds": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "any-failed-dish": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "any-fruit": [
    "es",
    "pt-BR"
  ],
  "any-mushroom": [
    "es",
    "pt-BR"
  ],
  "any-rainbow-sugar": [
    "es",
    "pt-BR"
  ],
  "any-vegetable": [
    "es",
    "pt-BR"
  ],
  "apollo": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "apple": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "apple-jam": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "apple-milkshake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "apple-pie": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "apple-verbena-pie": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "arctic-char": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "asian-arowana": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "asian-lady-beetle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "asparagus-beetle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "atlantic-mackerel": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "atlantic-puffin": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "atlantic-pygmy-octopus": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "atlantic-salmon": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "atlas-beetle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "audouins-gull": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "auto-bird-whistle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "avocado": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "avocado-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "axe": [
    "es",
    "pt-BR",
    "th",
    "de",
    "id"
  ],
  "azores-bullfinch": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "azure-demoiselle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "azure-tit": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "bagworm-moth": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "baikal-teal": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "bait": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "baked-eggplant-w-meat": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "bamboo": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "barbel": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "bearded-reedling": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "beautiful-demoiselle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "beautiful-leopard": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "beltfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "bizarre-button-mushroom-blue": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "bizarre-button-mushroom-green": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "bizarre-button-mushroom-red": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "bizarre-food": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "bizarre-oyster-mushroom-orange": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "bizarre-oyster-mushroom-pink": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "bizarre-oyster-mushroom-purple": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "bizarre-penny-bun-pink": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "bizarre-penny-bun-purple": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "bizarre-penny-bun-red": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "bizarre-shiitake-black": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "bizarre-shiitake-blue": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "bizarre-shiitake-red": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "bizzare-drink": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "black-calla-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "black-carnation": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "black-corn-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "black-highland-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "black-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "black-morning-glory": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "black-motorcycle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "black-pansy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "black-peafowl": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "black-rose": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "black-sedan": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "black-stork": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "black-swan": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "black-truffle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "black-truffle-cream-pasta": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "black-truffle-pie": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "black-tulip": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blackspot-seabream": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blackspot-sergeant": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-and-yellow-macaw": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-and-yellow-wrasse": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-brick-clownfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-brick-large-red-damselfly": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-brick-sparrow": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-european-crayfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-european-crayfish-sashimi": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-footed-booby": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-headed-quail-dove": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-highland-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-morpho": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-peafowl": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-roll-cake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-rose": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-sedan": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-shieldbug": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-sugar": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-suit-dove": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blue-tulip": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blueberry": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blueberry-jam": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blueberry-milkshake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "blueberry-verbena-pie": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "bluefin-tuna": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "bluegill": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "branch": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "brick-black-truffle-patty-burger": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "brick-bowl-apple-shaved-ice": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "brick-bowl-blueberry-shaved-ice": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "brick-bowl-fruit-shaved-ice": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "brick-bowl-grape-shaved-ice": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "brick-bowl-mandarin-shaved-ice": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "brick-bowl-pineapple-shaved-ice": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "brick-bowl-raspberry-shaved-ice": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "brick-bowl-strawberry-shaved-ice": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "brick-button-mushroom-patty-burger": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "brick-fun-combo-set": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "brick-mushroom-patty-burger": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "brick-oyster-mushroom-patty-burger": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "brick-penny-bun-patty-burger": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "brick-shiitake-patty-burger": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "brown-noddy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "bumblebee": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "bunny": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "burbot": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "burdock": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "butter": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "butterfly-koi": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "button-mushroom": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "button-mushroom-pie": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "cabbage-white": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "cacao": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "cacao-seed": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "calla-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "calla-lily-seeds": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "camouflage-bush": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "candlelight-dinner": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "capybara": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "caramel-popcorn-bucket": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "carnation": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "carnation-seeds": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "carrot": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "carrot-cake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "carrot-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "cat-food": [
    "es",
    "id",
    "pt-BR",
    "de",
    "th"
  ],
  "cerulean-carpenter": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "cheese": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "cheese-cake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "chestnut-cheeked-starling": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "chestnut-tiger": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "chocolate-sauce": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "chum-salmon": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "cicada": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "cinnamon-ground-dove": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "clownfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "cocoa": [
    "es",
    "pt-BR"
  ],
  "cocoa-milk-tea": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "cocoa-milkshake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "coffee": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "coffee-beans": [
    "es",
    "id",
    "pt-BR",
    "de",
    "th"
  ],
  "coffee-latte": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "colorful-brick-clownfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "colorful-brick-large-red-damselfly": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "colorful-brick-sparrow": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "colorful-egg-feast": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "colorful-movie-combo": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "comet-moth": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "common-barbel": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "common-bleak": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "common-blue-butterfly": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "common-brimstone": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "common-carp": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "common-chub": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "common-kestrel": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "common-octopus": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "common-prawn": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "common-rudd": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "common-shrimp": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "common-whitefish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "common-whitetail": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "conehead-mantis": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "cooking-oil": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "corn": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "corn-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "corn-poppy-seeds": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "corn-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "corn-soup": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "crafty-repair-kit": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "cranesbill": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "cranesbill-seeds": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "crayfish-sashimi": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "crimson-marsh-glider": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "crucian-carp": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "daisy": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "daisy-seeds": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "daisy-tea": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "dandelion": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "deer": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "deluxe-seafood-platter": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "director-common-octopus-w-cinnamon-hat": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "director-common-octopus-with-patterned-hat": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "director-pygmy-octopus-w-brown-hat": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "director-pygmy-octopus-w-cyan-hat": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "director-pygmy-octopus-w-navy-hat": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "dog-food": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "double-barred-finch": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "dreamlight-cinematics-popcorn-serving-cart": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "dye": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "eagle-owl": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "eastern-bluebird": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "edible-frog": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "egg": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "eggplant": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "eggplant-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "eggs": [
    "es",
    "pt-BR"
  ],
  "elegant-flower-beetle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "eurasian-bullfinch": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "eurasian-chaffinch": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "eurasian-collared-dove": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "eurasian-golden-oriole": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "eurasian-nuthatch": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "eurasian-wigeon": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "eurasian-wren": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "european-bee-eater": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "european-crayfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "european-eel": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "european-firebug": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "european-flying-squid": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "european-lobster": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "european-mudminnow": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "european-perch": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "european-plaice": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "european-robin": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "european-shag": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "european-smelt": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "exquisite-afternoon-tea": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "false-scad": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "ferret": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "fertilizer": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "fiddlehead": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "fire-colored-beetle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "fish-and-chips": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "fish-n-chips": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "fishing-rod": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "flamer-skimmer": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "flawless-fluorite": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "flour": [
    "es",
    "pt-BR"
  ],
  "four-spotted-ladybug": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "four-spotted-skimmer": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "fox": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "free-spirited-coffee-umbrella": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "freshwater-blenny": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "frosted": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "frostspore-king-crab": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "frostspore-mother-of-pearl": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "frostspore-ocean-sunfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "frostspore-postman-butterfly": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "frostspore-puffer-fish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "frostspore-purple-spotted-swallowtail": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "frostspore-queen-alexandras-birdwing": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "frostspore-seahorse": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "frostspore-sulkowskys-morpho": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "frostspore-whale-shark": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "fruit-verbena-pie": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "giant-asian-mantis": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "giant-oarfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "glasswing-butterfly": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "goby": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "gold-grasshopper": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "golden-jewel-scarab": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "golden-king-crab": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "golden-script-supervisor-bumblebee": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "golden-stag-beetle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "goldfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "goliath-beetle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "grape": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "grape-jam": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "grape-milkshake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "grape-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "grape-verbena-pie": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "grass-cake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "gray-suit-dove": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "grayling": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "great-green-macaw": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "great-tit": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "greater-asian-lady-beetle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "greater-flamingo": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-birdwing": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-brick-clownfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-brick-sparrow": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-carnation": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-daisy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-egg": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-highland-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-laceleaf": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-metalwing": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-milk-tea": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-motorcycle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-peafowl": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-roll-cake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-script-supervisor-bumblebee": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-sea-turtle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-snail": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-sugar": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-suit-dove": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-tea": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "green-tiger-beetle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "grilled-button-mushroom": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "grilled-mushrooms": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "grilled-oyster-mushroom": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "grilled-penny-bun": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "grilled-shiitake-mushroom": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "growth-booster": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "haddock": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "hawfinch": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "heart-puppies-con-panna": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "hercules-beetle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "hermit-crab": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "highland-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "highland-poppy-seeds": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "horned-beetle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "horse-mackerel": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "house-salad": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "huchen": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "hyacinth": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "hyacinth-seeds": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "imperial-shag": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "inca-tern": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "indigo-roll-cake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "indigo-sugar": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "inflatable-insect-attractor": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "insect-net": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "jam": [
    "es",
    "pt-BR"
  ],
  "jambu-fruit-dove": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "katydid": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "king-crab": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "king-eider": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "laceleaf": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "laceleaf-seeds": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "lady-amherst-pheasant": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "large-banded-grasshopper": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "large-flower-bed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "large-pearl-mussel": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "large-red-damselfly": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "large-vivarium": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "largemouth-bass": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "latte": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "lears-macaw": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "lesser-flamingo": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "lettuce": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "lettuce-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "lily-seeds": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "lionfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "lionhead": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "llama": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "loam": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "long-eared-owl": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "long-tailed-tit": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mahi-mahi": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mallard": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "maltese-canele": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "maltese-con-panna": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mandarin": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mandarin-jam": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mandarin-milkshake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mandarin-verbena-pie": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "master-repair-kit": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "matcha-green-milk-tea": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "matcha-milkshake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "matcha-powder": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "matsutake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "meat": [
    "es",
    "id",
    "pt-BR",
    "de",
    "th"
  ],
  "meat-burger": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "meat-sauce-pasta": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mediterranean-killifish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mediterranean-mantis": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "medium-flower-bed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "medium-vivarium": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "medium-wall-plant-frame": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mellow-black-tea": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mellow-milk-tea": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mermaid-fish-attractor": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mermaid-perfume": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "milk": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "milkshake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mini-moon-moth": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "minnow": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "minotaur-beetle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mixed-jam": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "moon-jelly": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "moonfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "morning-glory": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "morning-glory-seeds": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "morpho-helena": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "moth-orchid": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "moth-orchid-seeds": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "mother-of-pearl": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mottled-sculpin": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mourning-cloak": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mud-sunfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mushroom-pie": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mussel": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "mustard-greens": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "northern-pike": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "nursehound": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "ocean-sunfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "old-world-swallowtail": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "onsen-egg": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "orange": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "orange-calla-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "orange-carnation": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "orange-corn-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "orange-egg": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "orange-highland-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "orange-laceleaf": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "orange-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "orange-morning-glory": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "orange-pansy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "orange-roll-cake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "orange-rose": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "orange-sugar": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "orange-tip": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "orange-tulip": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "orchid-mantis": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "ore": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "oriental-shrimp": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "original-roll-cake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "oyster-mushroom": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "oyster-mushroom-pie": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "paddy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "panda": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pansy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pansy-seeds": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "paradise-tanager": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pasteurized-egg": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "peach-calla-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "peach-carnation": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "peach-highland-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "peach-laceleaf": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "peach-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "peach-morning-glory": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "peach-rose": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "peach-tulip": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "peacock-butterfly": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "penguin": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "penny-bun": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "penny-bun-pie": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "peregrine-falcon": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "picasso-bug": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "picnic-set": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pied-imperial-pigeon": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pillow-shaped-egg-yolk-and-pork-zongzi": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pillow-shaped-plain-rice-zongzi": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pillow-shaped-red-bean-zongzi": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pine-grosbeak": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pineapple": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pineapple-jam": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pineapple-milkshake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pineapple-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pineapple-verbena-pie": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-betta": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-brick-large-red-damselfly": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-brick-sparrow": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-calla-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-carnation": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-corn-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-daisy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-daisy-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-highland-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-katydid": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-laceleaf": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-morning-glory": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-motorcycle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-necked-green-pigeon": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-pigeon": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-rose": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-script-supervisor-bumblebee": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-sedan": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pink-tulip": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "planter": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "postman-butterfly": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "potato-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "potatoes": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "przevalskis-parrotbill": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "puffer-fish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "pumpkinseed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "purple-brick-clownfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "purple-brick-large-red-damselfly": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "purple-brick-sparrow": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "purple-calla-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "purple-corn-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "purple-egg": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "purple-emperor": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "purple-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "purple-morning-glory": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "purple-pansy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "purple-rose": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "purple-script-supervisor-bumblebee": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "purple-spotted-swallowtail": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "purple-tulip": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "quality-fertilizer": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "quality-growth-booster": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "quality-timber": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "queen-alexandra-s-birdwing": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "rabbit-fish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "rainbow-bouquet": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "rainbow-breeding-powder": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "rainbow-heart": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "rainbow-spark": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "rainbow-stag-beetle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "rajah-brookes-birdwing": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "rare-timber": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "raspberry": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "raspberry-jam": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "raspberry-milkshake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "raspberry-verbena-pie": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-and-green-macaw": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-bean": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-bellied-piranha": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-brick-clownfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-browed-finch": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-calla-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-calla-lily-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-carnation": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-carnation-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-corn-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-corn-poppy-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-daisy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-daisy-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-faced-cormorant": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "red-highland-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-highland-poppy-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-laceleaf": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-laceleaft-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-milkweed-locust": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-morning-glory": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-morning-glory-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-motorcycle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-pansy-seed": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "red-roll-cake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-script-supervisor-bumblebee": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-sugar": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "red-suit-dove": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "redpoll": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "regent-bowerbird": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "repair-kit": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "retriever-canele": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "retriever-con-panna": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "rice-flour": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "river-crab": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "roaming-oak-timber": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "romaine-lettuce": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "romaine-lettuce-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "romaine-lettuce-taco": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "rose": [
    "es",
    "id",
    "pt-BR",
    "de",
    "th"
  ],
  "rose-seeds": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "rose-tea": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "ruddy-shelduck": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "ruffe": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "rustic-ratatouille": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "salsa-sauce": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "salsa-wavy-potato-chips": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "sardine": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "savory-double-combo-bucket": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "savory-popcorn-bucket": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "scad": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "scanner": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "scarce-morpho": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "schneider": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "sea-bass": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "sea-otter": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "sea-stickleback": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "seafood-pizza": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "seafood-risotto": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "seagull": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "seahorse": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "selene-carnation": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "selene-daisy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "selene-highland-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "selene-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "selene-morning-glory": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "selene-rose": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "sense-booster": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "seven-spotted-ladybug": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "shiitake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "shiitake-pie": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "shortfin-mako-shark": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "siberian-grasshopper": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "silver-jewel-scarab": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "silver-throated-tit": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "simplistic-mountain-bike": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "skipjack-tuna": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "small-flower-bed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "small-vivarium": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "smew": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "smoked-fish-bagel": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "smooth-hammerhead": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "snowball": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "snowy-owl": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "spanish-moon-moth": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "spectacled-owl": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "spined-loach": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "splay-footed-carpenter": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "springdag-raspberry-black-tea": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "springday-apple-black-tea": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "springday-blueberry-black-tea": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "springday-brown-sugar": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "springday-fruit-black-tea": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "springday-grape-black-tea": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "springday-mandarin-black-tea": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "springday-pineapple-black-tea": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "springday-strawberry-black-tea": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "square-flower-bed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "stag-beetle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "starfall-shard": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "steamed-golden-king-crab": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "steamed-king-crab": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "stock-dove": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "stone": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "stone-loach": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "strawberry": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "strawberry-jam": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "strawberry-milkshake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "strawberry-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "strawberry-verbena-pie": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "streber": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "striped-red-mullet": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "striped-suit-dove": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "sugar": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "sulkowskys-morpho": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "sunglow-calla-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "sunglow-highland-poppy": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "sunglow-pansy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "sunglow-rose": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "sunglow-tulip": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "sunset-morpho": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "supreme-movie-meal": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "sweet-duo-bucket": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "swordfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "tablet": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "tadpole": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "tall-mustard": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "tea": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "tea-leaves": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "tea-tree-seed": [
    "es",
    "pt-BR"
  ],
  "tench": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "tern": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "three-spined-stickleback": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "tilapia": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "timber": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "tiramisu": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "tomato": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "tomato-sauce": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "tomato-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "top-fertilizer": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "top-growth-booster": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "triangle-egg-yolk-and-pork-zongzi": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "triangle-plain-rice-zongzi": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "triangle-red-bean-zongzi": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "trout": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "tub-gurnard": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "tulip": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "tulip-seeds": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "turbot": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "universal-animal-food": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "universal-ingredient": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "verditer-flycatcher": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "violet-roll-cake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "violet-sugar": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "wallaces-fruit-dove": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "waroona-cuckoo-bee": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "wasp-beetle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "watering-can": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "weed": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "weeds": [
    "es",
    "pt-BR"
  ],
  "wels-catfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "whale-shark": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "wheat": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "wheat-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-calla-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-calla-lily-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-carnation": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-carnation-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-convertible": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-corn-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-corn-poppy-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-daisy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-daisy-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-faced-surgeonfish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-headed-duck": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-highland-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-highland-poppy-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-laceleaf": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-laceleaft-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-morning-glory": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-morning-glory-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-motorcycle": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-peafowl": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-radish": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-radish-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-rose": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-sugar": [
    "es",
    "pt-BR"
  ],
  "white-tulip": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-wagtail": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "white-witch": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "whooper-swan": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "wild-bracken-celtuce-taco": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "wild-burdock-celtuce-taco": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "wild-garlic-mustard-celtuce-taco": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "wild-mustard-greens-celtuce-taco": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "wild-vegetable-celtuce-taco": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "winter-eurasian-wigeon": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "winter-frost-season-apple-frosted-pancake": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "winter-frost-season-aurora-banquet": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "winter-frost-season-blueberry-frosted-pancake": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "winter-frost-season-creamy-white-radish-soup": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "winter-frost-season-iced-coffee": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "winter-frost-season-iced-latte": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "winter-frost-season-mandarin-frosted-pancake": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "winter-frost-season-original-frosted-pancake": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "winter-frost-season-raspberry-frosted-pancake": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "winter-frost-season-steak-w-mashed-white-radish": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "winter-greater-flamingo": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "winter-mallard": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "winter-mandarin-duck": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "winter-smew": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "wonga-pigeon": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "woodchat-shrike": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-bellied-flycatcher": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "yellow-brick-large-red-damselfly": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-calla-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-calla-lily-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-carnation": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-carnation-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-corn-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-corn-poppy-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-highland-poppy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-highland-poppy-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-laceleaf": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-laceleaft-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-lily": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-morning-glory-seed": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-pansy": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-pansy-seed": [
    "es",
    "pt-BR",
    "de",
    "id",
    "th"
  ],
  "yellow-roll-cake": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-rose": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-sedan": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-sugar": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "yellow-tulip": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "zander": [
    "es",
    "id",
    "pt-BR",
    "th",
    "de"
  ],
  "agrias-butterfly": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "alpaca-cupcake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "alpaca-paw-candy": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "american-paddlefish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "amur-catfish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "apple-cake": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "apple-cloud-candy": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "apple-frosted-pancake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "apple-hermit-crab": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "apple-ice-cream": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "apple-jam-meatball": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "apple-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "apple-pearl-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "apple-princess-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "apple-pudding": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "audouin-s-gull": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "aurora-banquet": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "baked-eggplant-w-meat-sauce": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "balloon-morpho": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "balloon-nymphalidae": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "balloon-swallowtail": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "bamboo-tube-apple-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "bamboo-tube-blueberry-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "bamboo-tube-dragonfruit-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "bamboo-tube-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "bamboo-tube-mandarin-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "bamboo-tube-raspberry-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "bandage-fish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "bean-paste-tangyuan": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "beet": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "berry-cake": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "berry-pie": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "black-calla-lily-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "black-cranesbill": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "black-cranesbill-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "black-dandelion": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "black-diamond-mussel": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "black-hyacinth": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "black-moth-orchid": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "black-rose-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "black-tulip-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "black-turkey": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-camping-sparrow": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-clockwork-sparrow": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-coast": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-cranesbill": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-cranesbill-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-dandelion": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-diamond-mussel": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-dung-beetle": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-floating-dust-bug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-hat-stock-dove": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-hyacinth": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-jello-fish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-light-firefly": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-light-jellyfish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-milkweed-beetle": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-moth-orchid": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-red-betta": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-rose-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-starry-stock-dove": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-starry-swan": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blue-tulip-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blueberry-cloud-candy": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blueberry-frosted-pancake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blueberry-hermit-crab": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blueberry-ice-cream": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blueberry-jam-meatball": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blueberry-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blueberry-pearl-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blueberry-princess-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "blueberry-pudding": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "blueberry-toast": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "bottled-apple-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "bottled-blueberry-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "bottled-iced-milk": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "bottled-mandarin-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "bottled-raspberry-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "bourbon-red-turkey": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "brown-camping-sparrow": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "brown-clockwork-sparrow": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "brown-hat-stock-dove": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "brown-sauna-hat-sea-turtle": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "bunny-cupcake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "bunny-paw-candy": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "burdock-celtuce-taco": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "candy-corn-fish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "cappuccino": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "capybara-cupcake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "capybara-paw-candy": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "carrot-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "cheese-crayfish-stuffed-crab-claws": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "cheesy-baked-eggplants": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "chocolate-mooncake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "cinnamoroll-crepe": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "claypot-seafood-soup": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "claypot-tomato-soup": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "clockwork-frog": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "coal-bug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "cocoa-bean": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "coconut": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "coconut-ice-cream": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "coconut-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "coconut-pudding": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "coffee-cupcake": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "coffee-ice-cream": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "coffee-pudding": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "coffee-toast": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "colorful-movie-meal": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "corn-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "cozy-afternoon-tea": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "cozy-borscht": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "cozy-carrot-borscht": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "cozy-classic-meatball": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "cozy-corn-borscht": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "cozy-custard-sauce": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "cozy-potato-borscht": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "cozy-tomato-borscht": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "crawling-firecracker-bug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "crayfish-avocado-cup": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "cream-cake": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "creamy-white-radish-soup": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "cupcake": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "deer-cupcake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "deer-paw-candy": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "dragonfruit-hermit-crab": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "dragonfruit-jam": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "eastern-lubber-grasshopper": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "edible-star-powder": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "eerie-pumpkin-bowl": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "eerie-pumpkin-pie": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "eerie-pumpkin-soup": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "egg-dumpling": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "egg-pudding": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "egg-rice-bowl-banchos-pick": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "eggplant-pasta": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "fermented-dough": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "ferret-cupcake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "ferret-paw-candy": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "fiddlehead-celtuce-taco": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "firefly-squid": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "fish-chips": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "flame-skimmer": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "flat-white": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "flatback-turtle": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "flower-cake": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "flying-firecracker-bug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "fox-cupcake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "fox-paw-candy": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "fried-shrimp-sushi-banchos-pick": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "frozen-sausage": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "fruit-jam-meatball": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "fruit-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "fruit-princess-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "ghost-frog": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "ghost-lollipop": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "gin-matsuba-koi": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "glass-rose-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "glasswort": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "glasswort-shrimp-fried-rice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "gold-bug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "golden-clockwork-ladybug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "golden-dung-beetle": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "golden-koi": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "golden-mussel": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "golden-pheasant": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "grape-cloud-candy": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "grape-ice-cream": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "grape-jam-meatball": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "grape-juice": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "grape-princess-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "gray-bouncy-dust-insect": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "gray-camping-sparrow": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "gray-clockwork-sparrow": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "great-black-firefly": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "green-bath-towel-mako-shark": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "green-bouncy-dust-bug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "green-camping-sparrow": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "green-cranesbill": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "green-cranesbill-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "green-dung-beetle": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "green-flower-chafer": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "green-hat-stock-dove": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "green-jello-fish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "green-light-firefly": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "green-light-jellyfish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "green-light-sea-star": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "green-starry-stock-dove": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "green-starry-swan": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "grey-mantled-albatross": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "grilled-mushroom": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "grilled-shiitake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "grilled-squid-w-apple-jam": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "grilled-squid-w-blueberry-jam": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "grilled-squid-w-fruit-jam": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "grilled-squid-w-pineapple-jam": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "grilled-squid-w-starfruit-jam": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "grilled-squid-w-strawberry-jam": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "grimkin-pumpkin-bowl": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "grimkin-pumpkin-pie": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "grimkin-pumpkin-soup": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "hanging-firecracker-bug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-apple-yogurt-bowl": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-black-diamond-mussel": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-blue-diamond-mussel": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-blueberry-yogurt-bowl": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-corn-toast": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-golden-mussel": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-grape-yogurt-bowl": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-jade-mussel": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-lettuce-toast": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-mandarin-yogurt-bowl": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-matsutake-soup": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-meal": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-mussel": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-nut-yogurt-bowl": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-nuts": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-pineapple-yogurt-bowl": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-purple-diamond-mussel": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-raspberry-yogurt-bowl": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-strawberry-yogurt-bowl": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-tomato-toast": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "harvest-yogurt": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "ice-bug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "ice-cream": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "iced-cup-coffee": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "iced-cup-latte": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "indigo-hanging-dust-bug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "indigo-jello-fish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "inflatable-mallard": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "inflatable-ruddy-shelduck": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "inflatable-smew": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "inflatable-wigeon": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "jade-mussel": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "jady-blue-jellyfish-tartare": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "jady-green-jellyfish-tartare": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "jady-jellyfish-tartare": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "jady-purple-jellyfish-tartare": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "japanese-flying-squid": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "jelly-treatsure-firefly": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "jellybean-treatsure-butterfly": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "jumping-firecracker-bug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "kissing-fish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "koi": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "kuromi-crepe": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "lady-amherst-s-pheasant": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "large-chocolate-mooncake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "large-egg-yolk-mooncake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "large-moon-rabbit-snow-skin-mooncake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "little-egret": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "lollipop-treatsure-dragonfly": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "lychee-shieldbug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "mandarin-cake": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "mandarin-cloud-candy": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "mandarin-cupcake": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "mandarin-duck": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "mandarin-fish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "mandarin-frosted-pancake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "mandarin-hermit-crab": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "mandarin-ice-cream": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "mandarin-jam-meatball": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "mandarin-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "mandarin-pearl-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "mandarin-princess-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "mandarin-pudding": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "marinade-powder": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "marinated-catfish-fillets": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "marinated-fillets": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "marinated-paddlefish-fillets": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "marinated-pufferfish-fillets": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "marshmallow": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "mashed-potato": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "meat-dumpling": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "milk-cupcake": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "milk-toast": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "mint": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "mixed-vegetable-puree": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "mixed-vegetable-soup": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "moon-rabbit-snow-skin-mooncake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "mooncake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "morpho-luna": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "mummy-cat-drink": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "mustard-greens-celtuce-taco": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "my-melody-crepe": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "new-year-fortune-fish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "ocean-feast": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "ocean-iced-drink": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "ocellated-turkey": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "olive-ridley-turtle": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "orange-calla-lily-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "orange-camping-sparrow": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "orange-cranesbill": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "orange-cranesbill-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "orange-dandelion": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "orange-hyacinth": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "orange-jello-fish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "orange-moth-orchid": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "orange-rose-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "orange-tulip-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "oriental-magpie": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "original-cloud-candy": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "original-frosted-pancake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "palmier-treatsure-butterfly": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "panda-cupcake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "panda-paw-candy": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "parsley": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pasta": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "pea": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "pea-puree": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "pea-soup": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "peach-calla-lily-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "peach-cranesbill": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "peach-cranesbill-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "peach-dandelion": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "peach-hyacinth": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "peach-moth-orchid": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "peach-rose-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "peach-tulip-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "permit": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "persimmon": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "persimmon-ruyi-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pied-falconet": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pied-kingfisher": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pineapple-cloud-candy": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pineapple-ice-cream": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pineapple-jam-meatball": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pineapple-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pineapple-princess-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pineapple-pudding": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "pink-atlantic-salmon": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pink-calla-lily-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pink-cranesbill": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pink-cranesbill-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pink-dandelion": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pink-hanging-dust-bug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pink-hat-stock-dove": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pink-hyacinth": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pink-king-crab": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pink-light-firefly": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pink-memory": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pink-moth-orchid": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pink-necked-firefly": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pink-rose-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pink-seahorse": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pink-shortfin-mako-shark": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pink-swordfish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pink-tulip-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pomarine-skua": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "potato": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "psionic-indian-fritillary": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "psionic-luna-moth": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "psionic-queen-alexandra-s-birdwing": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "psionic-rimmed-window-firefly": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pudding": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "puff-treatsure-ladybug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pumpkin": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "pumpkin-lollipop": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "purple-calla-lily-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "purple-dandelion": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "purple-diamond-mussel": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "purple-dung-beetle": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "purple-floating-dust-bug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "purple-hyacinth": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "purple-jello-fish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "purple-light-firefly": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "purple-light-jellyfish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "purple-light-sea-star": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "purple-moth-orchid": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "purple-rose-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "purple-starry-stock-dove": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "purple-starry-swan": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "purple-tulip-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "qiaoguo": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "rajah-brooke-s-birdwing": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "raspberry-cloud-candy": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "raspberry-cupcake": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "raspberry-frosted-pancake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "raspberry-hermit-crab": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "raspberry-ice-cream": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "raspberry-jam-meatball": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "raspberry-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "raspberry-pearl-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "raspberry-princess-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "raspberry-pudding": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "raspberry-toast": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "red-clockwork-ladybug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "red-cranesbill": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "red-cranesbill-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "red-crowned-crane": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "red-dandelion": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "red-dung-beetle": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "red-hyacinth": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "red-jello-fish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "red-koi": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "red-moth-orchid": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "red-rose-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "red-tulip-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "rimmed-window-firefly": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "rock-bug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "roll-cake-treatsure-snail": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "roseate-spoonbill": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "royal-palm-turkey": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "salsa": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "salsa-rippled-potato-chips": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "savory-duo-bucket": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "scallop": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "sea-grape": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "sea-grape-shiitake-chawanmushi": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "sea-otter-cupcake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "sea-otter-paw-candy": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "sea-slug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "seashell-pearl-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "selene-cranesbill": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "selene-cranesbill-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "selene-dandelion": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "selene-moth-orchid": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "selene-rose-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "simmered-claypot-soup": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "small-xmas-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "snow-bug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "snowy-window-firefly": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "spectral-octopus": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "spirulina-powder": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "springday-picnic-set": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "springday-raspberry-black-tea": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starfruit": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starfruit-jam": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starfruit-pearl-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starry-apple-donut": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starry-apple-mint-milk": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starry-blueberry-donut": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starry-blueberry-mint-milk": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starry-fruit-donut": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starry-fruit-mint-milk": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starry-grape-donut": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starry-grape-mint-milk": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starry-mandarin-donut": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starry-mandarin-mint-milk": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starry-meal": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starry-pineapple-donut": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starry-pineapple-mint-milk": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starry-raspberry-donut": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starry-raspberry-mint-milk": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starry-strawberry-donut": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "starry-strawberry-mint-milk": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "steak-w-mashed-white-radish": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "steamed-cured-meat": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "steamed-ribs-w-rice-powder": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "strawberry-cloud-candy": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "strawberry-ice-cream": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "strawberry-jam-meatball": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "strawberry-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "strawberry-princess-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "striped-bath-towel-mako-shark": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "striped-sauna-hat-sea-turtle": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "sulkowsky-s-morpho": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "sunglow-calla-lily-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "sunglow-cranesbill": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "sunglow-cranesbill-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "sunglow-hyacinth": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "sunglow-moth-orchid": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "sunglow-rose-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "sunglow-tulip-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "tall-mustard-celtuce-taco": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "tiger-puffer": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "toast": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "toasted-apple-marshmallow": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "toasted-blueberry-marshmallow": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "toasted-mandarin-marshmallow": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "toasted-marshmallow": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "toasted-pineapple-marshmallow": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "toasted-raspberry-marshmallow": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "toasted-strawberry-marshmallow": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "tomato-juice": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "tomato-seafood-soup": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "treatsure-candy-roll-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "treatsure-crispy-roll-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "treatsure-jelly-roll-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "treatsure-jellybean-roll-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "treatsure-puff-roll-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "treatsure-roll-cake": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "turkey": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "utopia-meal": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "utopian-corn-hotdog": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "utopian-grilled-sausage": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "utopian-lettuce-hotdog": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "utopian-original-hotdog": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "utopian-tomato-hotdog": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "vanilla": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "waffle-apple-ice-cream": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "waffle-blueberry-ice-cream": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "waffle-grape-ice-cream": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "waffle-mandarin-ice-cream": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "waffle-pineapple-ice-cream": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "waffle-raspberry-ice-cream": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "waffle-strawberry-ice-cream": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "waffle-vanilla-ice-cream": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "wakame": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "wakame-meatball-soup": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "wandering-albatross": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "white-banded-erebus-moth": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "white-clockwork-ladybug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "white-cranesbill": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "white-cranesbill-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "white-dandelion": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "white-dragonfruit": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "white-faced-storm-petrel": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "white-hat-stock-dove": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "white-hyacinth": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "white-moth-orchid": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "white-rose-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "white-sauna-hat-sea-turtle": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "white-spoonbill": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "white-tulip-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "white-winged-tern": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "whole-wheat-toast": [
    "de",
    "es",
    "pt-BR",
    "th",
    "id"
  ],
  "yellow-bath-towel-mako-shark": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "yellow-clockwork-ladybug": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "yellow-cranesbill": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "yellow-cranesbill-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "yellow-dandelion": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "yellow-hyacinth": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "yellow-light-firefly": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "yellow-moth-orchid": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "yellow-rose-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ],
  "yellow-tulip-seed": [
    "de",
    "es",
    "id",
    "pt-BR",
    "th"
  ]
} as Record<string, string[]>;
